// Character set accepted by fields that opt into printable-character validation.
// Angle brackets are deliberately excluded.
//
// This is a UX guard, not a security boundary: it is client-side only and trivially
// bypassed by calling the API directly. Real enforcement belongs server-side.
//
// Keep this as the single definition — it previously existed as three separate copies
// that drifted apart.
export const PRINTABLE_CHARS_REGEX =
  /[^ !"#$%^&'()*+,\-./0123456789:;=?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]_`abcdefghijklmnopqrstuvwxyz{|}~¡¢£¥¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ]+/;

export const PRINTABLE_CHARS_ERROR_MESSAGE =
  "An invalid character was found in this field. Please check your entry and try again.";
